export interface Message {
	title: string;
	text: string;
	value?: string;
}

export type AllowedPlaces =
	| 'general'
	| 'extrashoot'
	| 'appointment'
	| 'job'
	| 'productsPackages'
	| 'googleCalendar'
	| 'calendar'
	| 'paymentMethods'
	| 'clients'
	| 'csvFiles'
	| 'paymentSchedules'
	| 'companyUsers'
	| 'workflow'
	| 'emailTemplate'
	| 'emailSettings'
	| 'email'
	| 'contractTemplates'
	| 'jobTypes'
	| 'questionnaires'
	| 'companyInformation'
	| 'currencyAndTaxes'
	| 'jobView'
	| 'contract'
	| 'questions'
	| 'login'
	| 'forgotPassword'
	| 'refer'
	| 'unsubscribe'
	| 'payments'
	| 'editQuote'
	| 'editInvoice'
	| 'forgot'
	| 'subscription'
	| 'profile'
	| 'contactForm'
	| 'changeLogin'
	| 'stripe'
	| 'shootProof'
	| 'lead'
	| 'qb'
	| 'xero'
	| 'promoCodes'
	| 'attachments'
	| 'generalValidation'
	| 'consent'
	| 'subscribed'
	| 'fundy'
	| 'quoteCP';

export class Messages {
	public static general = {
		s: {
			0: {
				title: 'Success',
				text: '{value}',
				value: 'message from backend'
			},
			1: {
				title: 'Nice!',
				text: 'The client has given opt-in consent.'
			}
		},
		e: {
			0: {
				title: 'Whoops, something has gone wrong!',
				text: 'Please contact customer support.'
			},
			1: {
				title: 'Whoops!',
				text: 'Please enter a valid email address.'
			},
			2: {
				title: 'Error!',
				text: '{value}',
				value: 'error from backend'
			},
			3: {
				title: 'Houston, we have a problem!',
				text:
					'Only add letters into the {value} field, no spaces or strange symbols allowed.',
				value: "Field's name"
			}
		},
		i: {
			0: {
				title: 'Please wait',
				text: 'It may take a few minutes'
			},
			1: {
				title: '',
				text: '{value}',
				value: 'info from backend'
			}
		},
		w: {
			0: {
				title: "D'oh!",
				text: 'Please choose a date.'
			}
		}
	};

	public static consent = {
		s: {
			0: {
				title: 'Alrighty!',
				text: 'Consent has been successfully removed.'
			}
		},
		e: {
			0: {
				title: "Something's missing here!",
				text: 'Please complete the consent.'
			},
			1: {
				title: 'No-go!',
				text: "This consent doesn't exist anymore. Please refresh your page."
			},
			2: {
				title: 'No-go!',
				text: 'This consent is linked to a signed contract.'
			}
		}
	};

	public static extrashoot = {
		s: {
			0: {
				title: 'Ready, aim, FIRE!',
				text: 'Your extra shoot {value} has been deleted.',
				value: 'extrashoot name'
			},
			1: {
				title: 'Boom!',
				text: 'Your extra shoot has been saved.'
			},
			2: {
				title: 'Snap!',
				text: 'Your extra shoot details have been updated.'
			}
		},
		e: {
			0: {
				title: "That job doesn't exist!",
				text: 'Please add this extra shoot to an active job.'
			}
		},
		i: {},
		w: {}
	};

	public static appointment = {
		s: {
			0: {
				title: 'Locked and loaded!',
				text: 'Your appointment {value} has been created.',
				value: 'appointment name'
			},
			1: {
				title: 'Locked and loaded!',
				text: 'Your appointment {value} has been updated.',
				value: 'appointment name'
			},
			2: {
				title: 'Ready, aim, FIRE!',
				text: 'Your appointment {value} has been deleted.',
				value: 'appointment name'
			}
		},
		e: {
			0: {
				title: "What's going on here!",
				text:
					"Please enter a start and end time or tick 'all day' if this is an all day job."
			},
			1: {
				title: 'Jetlagged!',
				text: 'Please enter a start and end date.'
			},
			2: {
				title: 'Jetlagged!',
				text: 'The start time must be before the end date.'
			},
			3: {
				title: "That job doesn't exist!",
				text: 'Please add this appointment to an active job.'
			},
			4: {
				title: 'Whoops!',
				text: 'Please choose a client for the appointment reminder.'
			}
		},
		i: {},
		w: {}
	};

	public static job = {
		s: {
			0: {
				title: 'Mission accomplished!',
				text: 'A new job has been created.'
			},
			1: {
				title: 'Mission accomplished!',
				text: 'Your job details have been updated.'
			}
		},
		e: {
			0: {
				title: 'Jetlagged!',
				text: 'The start date must be before the end date.'
			},
			1: {
				title: 'Measure twice, cut once!',
				text: 'Please select or create a primary contact for this job.'
			},
			3: {
				title: "What's going on here!",
				text:
					"Please enter a start and end time or tick 'all day' if this is an all day job."
			},
			4: {
				title: 'Jetlagged!',
				text: 'The start time must be before the end date.'
			},
			5: {
				title: 'Oops!',
				text:
					'The secondary client needs to be different from the primary client.'
			}
		},
		i: {},
		w: {}
	};

	public static productsPackages = {
		s: {
			0: {
				title: "Now we're in business!",
				text: 'Your package {value} has been created.',
				value: 'product/package name'
			},
			1: {
				title: 'Dynamite!',
				text: 'Your package {value} has been deleted.',
				value: 'product/package name'
			},
			2: {
				title: 'Double down!',
				text: 'Your package {value} was successfully duplicated.',
				value: 'product/package name'
			},
			3: {
				title: 'Double down!',
				text: 'Your package {value} was successfully updated.',
				value: 'product/package name'
			},
			4: {
				title: "Now we're in business!",
				text: 'Your product {value} has been created.',
				value: 'product/package name'
			},
			5: {
				title: 'Dynamite!',
				text: 'Your product {value} has been deleted.',
				value: 'product/package name'
			},
			6: {
				title: 'Double down!',
				text: 'Your product {value} was successfully duplicated.',
				value: 'product/package name'
			},
			7: {
				title: 'Double down!',
				text: 'Your product {value} was successfully updated.',
				value: 'product/package name'
			},
			8: {
				title: 'Absolutely!',
				text: 'Your default introduction text for new Quotes have been updated.'
			},
			9: {
				title: 'Nice one Sensei!',
				text: 'Your product {value} has successfully converted into a package.',
				value: 'product/package name'
			},
			10: {
				title: 'Nice one Sensei!',
				text: 'Your package {value} has successfully converted into a product.',
				value: 'product/package name'
			}
		},
		e: {
			0: {
				title: 'Information needed Sensei!',
				text: 'Please enter a {value} name.',
				value: 'product or package'
			},
			1: {
				title: 'You can do better than that!',
				text: 'Please complete all fields before saving.'
			},
			2: {
				title: 'Information needed Sensei!',
				text: 'Please enter a {value} price.',
				value: 'product or package'
			},
			3: {
				title: 'Information needed Sensei!',
				text: 'Please enter a {value} description.',
				value: 'product or package'
			},
			4: {
				title: 'Houston, we have a problem!',
				text:
					'Only use letters in the default introduction text filed, no spaces or strange symbols allowed.'
			},
			5: {
				title: "Something's not adding up here!",
				text: 'Please make sure {value} value is greater than $0.',
				value: 'product or package'
			}
		},
		i: {},
		w: {}
	};

	public static googleCalendar = {
		s: {
			0: {
				title: 'Yes!',
				text: 'Your appointment reminder has been saved.'
			},
			1: {
				title: 'Looks like we have a bit of chemistry!',
				text: 'Google Calendar sync complete.'
			},
			2: {
				title: 'Locked and loaded!',
				text: 'Your Google Calendar has successfully been disconnected'
			}
		},
		e: {},
		i: {
			0: {
				title: 'Hold your horses!',
				text: 'Please be patient while we integrate with Google Calendar.'
			}
		},
		w: {}
	};

	public static calendar = {
		s: {
			0: {
				title: 'Tic toc tick!',
				text: 'You have successfully saved your Calendar preferences.'
			}
		},
		e: {},
		i: {},
		w: {}
	};

	public static paymentMethods = {
		s: {
			0: {
				title: 'Accepted!',
				text: 'Your PayPal credentials have been successfully saved.'
			},
			1: {
				title: 'Accepted!',
				text: 'Your Stripe credentials have been successfully saved'
			},
			2: {
				title: 'Happy days!',
				text: 'Your payment methods have been saved.'
			},
			4: {
				title: 'Congratulations!',
				text: 'Your PayPal payment was successful.'
			},
			5: {
				title: 'Congratulations!',
				text: 'Your Stripe payment was successful.'
			}
		},
		e: {
			0: {
				title: 'Almost there!',
				text: 'Please complete instructions for Transfer payment method.'
			},
			1: {
				title: 'Almost there!',
				text: 'Please complete all fields for Other payment method.'
			},
			2: {
				title: "We've hit a road block!",
				text:
					'Your Stripe details are not correct. Please double check them and try again.'
			},
			3: {
				title: 'No-go!',
				text: 'Please complete all PayPal fields.'
			},
			4: {
				title: 'No-go!',
				text: 'Please complete all Stripe fields.'
			},
			5: {
				title: "We've hit a road block!",
				text:
					'Your PayPal details are not correct. Please double check them and try again.'
			}
		},
		i: {},
		w: {}
	};

	public static clients = {
		s: {
			0: {
				title: 'Adios amigos!',
				text: 'Your client has been deleted.'
			},
			1: {
				title: 'Mission accomplished!',
				text: 'Your client has been updated.'
			},
			2: {
				title: 'Mission accomplished!',
				text: 'A new client has been created.'
			},
			3: {
				title: 'Scribble, scribble!',
				text: 'Your client notes have been saved.'
			},
			4: {
				title: 'To infinity and beyond!',
				text: 'Your email was sent.'
			}
		},
		e: {
			0: {},
			1: {
				title: 'Give it another go!',
				text: "Please complete the client's name and email address."
			},
			2: {},
			3: {},
			4: {
				title: 'Round 2!',
				text: "Please complete the client's first name."
			},
			5: {
				title: "That's strange!",
				text: 'You have entered too many characters in these fields'
			},
			6: {
				title: "You can't handle the truth!",
				text: 'The email address is already assigned to another client.'
			},
			7: {
				title: 'Sorry!',
				text:
					'Job specific variables cannot be used here. For Job specific variables to work, please send this email from within the Job that this client is assigned to. '
			},
			8: {
				title: 'Sorry!',
				text:
					'A client with the email {value} already exists in the system. Please enter a different email address.',
				value: 'client email'
			}
		},
		i: {},
		w: {}
	};

	public static csvFiles = {
		s: {
			0: {
				title: 'Cowabunga!',
				text: 'New clients have been successfully imported.'
			}
		},
		e: {
			0: {
				title: 'Double trouble!',
				text: 'You cannot import clients that already exist in the system.'
			},
			1: {
				title: "I don't think so!",
				text:
					"You're trying to upload the wrong file format. Please choose a CSV file."
			},
			2: {
				title: 'Please double check!',
				text: 'You cannot upload an empty CSV file.'
			},
			3: {
				title: 'Oops!',
				text:
					"Please add a 'First Name' to every contact in your CSV file. This is a mandatory field."
			},
			4: {
				title: 'Oops!',
				text:
					'Please add an email address to every contact in your CSV file. This is a mandatory field.'
			},
			5: {
				title: 'Double trouble!',
				text:
					'There are multiple contacts with the same email address in your CSV file. Please make sure each contact has a unique email address.'
			},
			6: {
				title: 'Double trouble!',
				text:
					'Contacts in your CSV file already exist in Studio Ninja. Please remove them from your CSV file and try again.'
			},
			7: {
				title: "That's not a Studio Ninja CSV file!",
				text:
					'Please make sure you download and use the Studio Ninja CSV file. CSV files exported from other software will not work.'
			},
			8: {
				title: "Don't mess with our file!",
				text: 'Please do not delete or rearrange the spreadsheet columns.'
			},
			9: {
				title: 'Double trouble!',
				text: 'Please upload one CSV file at a time.'
			}
		},
		i: {},
		w: {}
	};

	public static paymentSchedules = {
		s: {
			0: {
				title: 'Affirmative!',
				text: 'Your payment schedule {value} was created.',
				value: 'schedule name'
			},
			1: {
				title: 'Leave it to us!',
				text: 'Your invoice reminder has been updated.'
			},
			2: {
				title: 'See ya!',
				text: 'The payment schedule {value} has been deleted.',
				value: 'schedule name'
			},
			3: {
				title: 'Yipee!',
				text: 'Your payment schedule {value} has been updated.',
				value: 'schedule name'
			},
			4: {
				title: 'Leave it to us!',
				text: 'Your payment receipts have been updated.'
			}
		},
		e: {
			0: {
				title:
					"You're trying to save an Invoice Reminder email template without an invoice link!",
				text:
					"Please add the variable 'Invoice Link' to this email template before saving."
			},
			1: {
				title: "That's not going to add up!",
				text: 'You cannot add a percentage of more than 100%.'
			},
			2: {
				title: "You've forgotten something!",
				text:
					'Add a number into the days field so we know when to send out your payment reminders.'
			},
			3: {
				title: 'Something is not adding up here!',
				text:
					'You cannot create a payment for $0. Payments must be $1 or more. '
			}
		},
		i: {},
		w: {}
	};

	public static companyUsers = {
		s: {
			0: {
				title: 'Sorted!',
				text: 'The user {value} has been updated.',
				value: 'user email'
			},
			1: {
				title: "It's time to part ways!",
				text: 'Your company user {value} has been deleted.',
				value: 'user email'
			}
		},
		e: {
			0: {
				title: "Something's missing here!",
				text: 'Please complete the first name.'
			},
			1: {
				title: 'Things are looking a little empty in here!',
				text: 'Please complete the name and email address.'
			},
			2: {
				title: 'Try again!',
				text: 'Please complete the email address.'
			},
			3: {
				title: 'Think again!',
				text: 'That email address is invalid.'
			},
			4: {
				title: 'Whoops!',
				text: 'The user {value} is already registered in Studio Ninja',
				value: 'user email'
			},
			5: {
				title: 'Hmmm!',
				text: 'Unfortunately you cannot delete yourself.'
			},
			6: {
				title: "Something's missing here!",
				text: 'Please complete the business name.'
			}
		},
		i: {
			0: {
				title: 'You had me at hello!',
				text: 'An invitation has been sent to {value}.',
				value: 'user email'
			}
		},
		w: {}
	};

	public static workflow = {
		s: {
			0: {
				title: "And that's how it's done!",
				text: 'Your workflow {value} has been updated.',
				value: 'workflow name'
			},
			1: {
				title: 'Success!',
				text: 'Your workflow {value} has been created.',
				value: 'workflow name'
			},
			2: {
				title: 'So long, sucker!',
				text: 'The workflow {value} has been deleted.',
				value: 'workflow name'
			},
			3: {
				title: 'Boom!',
				text: 'You have successfully added a new workflow task.'
			},
			4: {
				title: 'Success sensei!',
				text: 'You have successfully edited your workflow task.'
			},
			5: {
				title: 'Adios amigo!',
				text: 'Your workflow task has been deleted.'
			}
		},
		e: {
			0: {
				title: 'Information needed Sensei!',
				text: 'Please enter a workflow name.'
			},
			1: {
				title: 'Taskmaster alert!',
				text: 'Please enter a task name.'
			},
			2: {
				title: "Don't rush!",
				text: '0 Days is not an option. Please choose 1 or more days.'
			},
			3: {
				title: 'You seem to have forgotten something!',
				text: 'Please choose an option before saving.'
			},
			4: {
				title: 'You seem to have forgotten something!',
				text:
					'Please choose an existing email template or create a new one before saving this task.'
			},
			5: {
				title: "You've forgotten something!",
				text: 'Please add a subject to this email before saving.'
			},
			6: {
				title: 'Hold your horses!',
				text:
					'You cannot delete a Workflow that is linked to a Job Type. Please un-link this Workflow and then try again.'
			}
		},
		i: {},
		w: {}
	};

	public static emailTemplate = {
		s: {
			0: {
				title: 'Boom!',
				text: 'The email template {value} has been deleted.',
				value: 'template name'
			},
			1: {
				title: 'See ya!',
				text: 'email template {value} has been deleted.',
				value: 'template name'
			},
			2: {
				title: 'Snap!',
				text: 'Your email settings have been saved.'
			},
			3: {
				title: 'Whoopee!',
				text: 'Your email template {value} has been updated.',
				value: 'template name'
			},
			4: {
				title: 'Woohoo!',
				text: 'Your email template {value} has been created.',
				value: 'template name'
			},
			5: {
				title: 'Woohoo!',
				text: 'Your email notification settings have been successfully saved.'
			}
		},
		e: {
			0: {
				title:
					"You're trying to save an Invoice email template without an invoice link!",
				text:
					"Please add the variable 'Invoice Link' to this email template before saving."
			},
			1: {
				title:
					"You're trying to save the Quote email template without a quote link!",
				text:
					"Please add the variable 'Quote Link' to this email template before saving."
			},
			2: {
				title:
					"You're trying to save the Contract email template without a contract link!",
				text:
					"Please add the variable 'Contract Link' to this email template before sending."
			},
			3: {
				title:
					"You're trying to save the Questionnaire email template without a questionnaire link!",
				text:
					"Please add the variable 'Questionnaire Link' to this email template before saving."
			},
			4: {
				title:
					"You're trying to save the Receipt of payment email template without a invoice link!",
				text:
					"Please add the variable 'Invoice Link' to this email template before saving."
			},
			5: {
				title: "Something's missing!",
				text:
					'Your email template is missing a contract link. Please add a contract link before saving this workflow task.'
			},
			6: {
				title: "Something's missing!",
				text:
					'Your email template is missing a questionnaire link. Please add a questionnaire link before saving this workflow task.'
			},
			7: {
				title: 'No can do, Sensei!',
				text:
					'This email template is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
			},
			8: {
				title: 'Double trouble!',
				text: 'Please use a different name as that one already exists.'
			},
			9: {
				title: "You've forgotten something!",
				text: 'Please add a {value} to this email template before saving.',
				value: 'field'
			},
			10: {
				title: "Something's not adding up here!",
				text: 'Please add a valid subject line to your email.'
			}
		},
		i: {},
		w: {}
	};

	public static emailSettings = {
		s: {
			0: {
				title: 'Woohoo!',
				text: 'Your Gmail account was successfully disconnected.'
			},
			1: {
				title: 'Woohoo!',
				text: 'Your SMTP server was successfully disconnected.'
			},
			2: {
				title: 'You have mail!',
				text: 'Your {value} settings have been successfully saved.',
				value: 'email server type'
			}
		},
		e: {
			0: {
				title: 'You forgot something!',
				text: "Please add your 'Reply to' email address."
			},
			1: {
				title: 'You forgot something!',
				text: "Please add your 'Sender name'."
			},
			2: {
				title: 'Houston we have a problem!',
				text: 'Please check your SMTP settings and try again.'
			},
			3: {
				title: 'Oops!',
				text: 'You forgot to input your {value}.',
				value: 'input field'
			},
			4: {
				title: 'Oops!',
				text: 'The port number you entered is incorrect.'
			},
			5: {
				title: 'Whoops!',
				text:
					'You cannot connect to Gmail because another user is connected to that Gmail account.'
			}
		},
		i: {
			0: {
				title: 'Chill out for a minute!',
				text: "We're just confirming your SMTP settings."
			},
			1: {
				title: 'Get ready to rumble!',
				text: 'Email address has been copied to clipboard.'
			}
		},
		w: {}
	};

	public static email = {
		e: {
			0: {
				title: 'Whoops!',
				text:
					'You cannot copy / paste images into the email message. Please attach the image instead.'
			},
			1: {
				title: 'Whoops!',
				text:
					"You cannot drag 'n' drop images into the email message. Please attach the image instead."
			}
		},
		s: {
			0: {
				title: 'Yas Queen!',
				text: 'Your mail box sync is complete.'
			}
		}
	};

	public static contractTemplates = {
		s: {
			0: {
				title: 'Goodbye!',
				text: 'The contract {value} has been deleted.',
				value: 'contract name'
			},
			1: {
				title: 'Woohoo!',
				text: 'The contract template {value} was successfully created.',
				value: 'contract name'
			},
			2: {
				title: 'Woohoo!',
				text: 'The contract template {value} has been updated.',
				value: 'contract template name'
			}
		},
		e: {},
		i: {},
		w: {}
	};

	public static jobTypes = {
		s: {
			0: {
				title: 'Bulls-eye!',
				text: 'The job type {value} has been deleted.',
				value: 'type name'
			},
			1: {
				title: 'You deserve a promotion!',
				text: 'Your job type {value} has been updated.',
				value: 'type name'
			},
			2: {
				title: "It's time to conquer!",
				text: 'Your job type {value} has been created.',
				value: 'type name'
			}
		},
		e: {
			0: {
				title: 'Error',
				text: 'Fill type name!',
				old: 'true'
			},
			1: {
				title: 'Hold your horses!',
				text: 'Please choose a Job Type colour before saving.'
			},
			2: {
				title: 'Hold your horses!',
				text: 'Please add a Job Type name before saving.'
			},
			3: {
				title: 'No can do, Sensei!',
				text:
					'You cannot delete the default Job Type. Set another Job Type to Default before deleting this one.'
			}
		},
		i: {},
		w: {}
	};

	public static questionnaires = {
		s: {
			0: {
				title: 'Cheerio!',
				text: 'The questionnaire {value} has been deleted.',
				value: 'questionnaire name'
			},
			1: {
				title: 'Slam dunk!',
				text: 'Your questionnaire {value} has been updated.',
				value: 'questionnaire name'
			},
			2: {
				title: "That's brilliant!",
				text: 'Your questionnaire {value} has been created.',
				value: 'questionnaire name'
			}
		},
		e: {
			0: {
				title:
					"You're trying to send a Questionnaire without a questionnaire link! ",
				text:
					"Please add the variable 'Questionnaire Link' to this email before sending."
			}
		},
		i: {},
		w: {}
	};

	public static companyInformation = {
		s: {
			0: {
				title: 'Hooray!',
				text: 'Your company information has been updated.'
			},
			1: {
				title: 'Be gone!',
				text: 'Your company has been successfully deleted.'
			}
		},
		e: {
			0: {
				title: "That's the wrong file format!",
				text: 'Please upload a JPG or PNG file.'
			},
			1: {
				title: 'That file is too BIG!',
				text: 'Please upload a file smaller than {value}mb.',
				value: ''
			},
			2: {
				title: 'That file is too BIG!',
				text: 'Please upload a file smaller than {value}mb.',
				value: ''
			},
			3: {
				title: 'Someone got in before you!',
				text:
					'The company name you are trying to save is already in use. Please use a different name.'
			}
		},
		i: {},
		w: {
			0: {
				title: 'Please wait!',
				text: 'Your company information update is still in progress.'
			}
		}
	};

	public static currencyAndTaxes = {
		s: {
			0: {
				title: 'Victory!',
				text: 'Your currency & taxes have been updated.'
			}
		},
		e: {},
		i: {},
		w: {}
	};

	public static jobView = {
		s: {
			0: {
				title: 'Adios!',
				text: 'Your job has been deleted.'
			},
			1: {
				title: 'Hasta la vista!',
				text: 'Your invoice has been deleted.'
			},
			// 2: {
			//    "title": "Pow!",
			//    "text": "Your contract has been deleted."
			// },
			3: {
				title: 'Scribble, scribble!',
				text: 'Your job notes have been saved.'
			},
			4: {
				title: 'To infinity and beyond!',
				text: 'Your contract was sent.'
			},
			// 5: {
			//    "title": "To infinity and beyond!",
			//    "text": "Your invoice was sent."
			// },
			6: {
				title: 'To infinity and beyond!',
				text: 'Your quote has been sent.'
			},
			// 7: {
			//    "title": "Toodle-oo!",
			//    "text": "Your questionnaire has been deleted."
			// },
			8: {
				title: 'Mission accomplished!',
				text: 'A new job has been created.'
			},
			9: {
				title: 'To identify and beyond!',
				text: 'Your questionnaire was sent.'
			}
		},
		e: {},
		i: {
			0: {
				title: 'Nice work!',
				text: 'Your workflow task has been updated.'
			}
		},
		w: {
			0: {
				title: 'Oops!',
				text: 'Please choose a contract template from the dropdown menu.'
			},
			1: {
				title: 'Oops!',
				text: 'Please choose a questionnaire template from the dropdown menu.'
			},
			2: {
				title: 'Patience, my friend!',
				text: 'You cannot create a new quote while another quote is pending.'
			}
		}
	};

	public static contract = {
		s: {
			0: {
				title: 'Pow!',
				text: 'Your contract has been deleted.'
			}
		},
		e: {
			0: {
				title: "You're trying to send a Contract without a contract link! ",
				text:
					"Please add the variable 'Contract Link' to this email before sending."
			},
			1: {
				title: 'No can do, Sensei!',
				text:
					'This contract is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
			}
		},
		i: {},
		w: {}
	};

	public static questions = {
		s: {
			0: {
				title: 'Toodle-oo!',
				text: 'Your questionnaire has been deleted.'
			}
		},
		e: {
			0: {
				title: 'No can do, Sensei!',
				text:
					'This questionnaire is linked to an active workflow task and cannot be deleted. Please delete the workflow task first.'
			}
		},
		i: {},
		w: {}
	};

	public static login = {
		s: {
			0: {
				title: "You're ready to go!",
				text: 'Please sign in.'
			},
			1: {
				title: 'Mission accomplished!',
				text: "It's time to login and get started."
			}
		},
		e: {
			0: {
				title: 'Houston, we have a problem!',
				text: 'Incorrect email or password.'
			},
			1: {
				title: 'Something is not adding up here!',
				text:
					'The email address you entered does not appear to be registered in the system.'
			},
			2: {
				title: 'It looks like that email address has already been registered!',
				text: 'Please choose a different email address and try again.'
			},
			3: {
				title: 'It looks like that company name has already been registered!',
				text: 'Please choose a different company name and try aqain.'
			},
			4: {
				title: 'Houston, we have a problem!',
				text:
					'Only use letters in the sign up form, no spaces or strange symbols allowed.'
			},
			5: {
				title: 'Oops! ',
				text: 'It seems like that activation link has already been used.'
			}
		},
		i: {},
		w: {
			0: {
				title: 'Ouch!',
				text: 'Please make sure your passwords match.'
			},
			1: {
				title: 'Even an apprentice could crack that code!',
				text: 'Your password must be at least 6 characters long.'
			}
		}
	};

	public static forgotPassword = {
		s: {},
		e: {
			0: {
				title: 'Ouch!',
				text: 'Please make sure your passwords match.'
			},
			1: {
				title: 'Even an apprentice could crack that code!',
				text: 'Your password must be at least 6 characters long.'
			},
			2: {
				title: 'Error',
				text: 'Forgot password link already used!'
			}
		},
		i: {},
		w: {}
	};

	public static refer = {
		s: {
			0: {
				title: 'Victory!',
				text:
					'Your Refer a Friend invitation to {value} has been successfully sent.',
				value: "friend's email"
			}
		},
		e: {},
		i: {},
		w: {}
	};

	public static unsubscribe = {
		s: {
			0: {
				title: 'Successfully unsubscribed!',
				text: 'You have been removed from this mailing list.'
			}
		},
		e: {
			0: {
				title: 'Oops!',
				text: 'You have already unsubscribed from this mailing list.'
			},
			1: {
				title: 'Sorry!',
				text:
					'You cannot unsubscribe from this mailing list becaue this email does not belong to you.'
			},
			2: {
				title: "We're losing you!",
				text: 'Unable to unsubscribe because the internet connection was lost. '
			}
		},
		i: {},
		w: {}
	};

	public static payments = {
		s: {
			0: {
				title: 'Maybe next time!',
				text: 'The invoice payment has been successfully reversed.'
			},
			1: {
				title: 'Show me the money!',
				text: 'Your invoice has been saved.'
			},
			2: {
				title: 'Show me the money!',
				text: 'Your quote has been saved.'
			},
			3: {
				title: 'Strike!',
				text: 'Your invoice has been marked as unpaid.'
			},
			4: {
				title: 'Cha-ching!',
				text: 'Your invoice has been saved.'
			},
			5: {
				title: 'Hasta la vista!',
				text: 'Your quote has been deleted.'
			},
			6: {
				title: 'Maybe next time!',
				text: 'Your invoice has been written off.'
			},
			7: {
				title: 'Money, money, moneyyy!',
				text: 'Your invoice has been paid.'
			},
			8: {
				title: 'Hasta la vista!',
				text: 'Your invoice has been deleted.'
			},
			9: {
				title: 'To infinity and beyond!',
				text: 'Your invoice has been sent.'
			},
			10: {
				title: 'To infinity and beyond!',
				text: 'Your quote has been sent.'
			},
			11: {
				title: 'To infinity and beyond!',
				text: 'Your receipt has been sent.'
			}
		},
		e: {
			0: {
				title: "You're good, but not that good!",
				text:
					'You cannot delete an invoice that is attached to an accepted quote. Please delete the quote first.'
			},
			3: {
				title: 'Look again!',
				text: 'Please put a number in the quantity field.'
			},
			4: {
				title: 'That discount is not going to work young apprentice!',
				text:
					'Please make sure all product/package tax options are identical otherwise the fixed discount will not work. Alternatively, you can use a percentage discount.'
			},
			5: {
				title: "Something's not adding up here!",
				text:
					'You cannot decrease the total of this invoice to a smaller amount.'
			},
			6: {
				title: 'Look again!',
				text:
					'You cannot save a product for $0. Please add a value in the price field.'
			}
		},
		i: {},
		w: {}
	};

	public static editQuote = {
		s: {
			0: {
				title: 'Voila!',
				text: 'An invoice has been created from your quote.'
			},
			1: {
				title: 'Ka-ching!',
				text: 'Your quote has been accepted.'
			}
		},
		e: {
			0: {
				title: 'D’oh!',
				text: 'This quote does not exist.'
			},
			1: {
				title: 'Generous, much!',
				text: 'The discount exceeds the quote total.'
			},
			2: {
				title: "Something's not adding up here!",
				text: "You're trying to give a discount more than 100% of the order."
			},
			3: {
				title: "You're trying to send a Quote without a quote link!",
				text:
					"Please add the variable 'Quote Link' to this email before sending."
			},
			4: {
				title: 'Jeez!',
				text: 'Please add at least one package or product.'
			},
			5: {
				title: "Something's not adding up here!",
				text:
					'The total value of your quote cannot be negative. Please add more fees.'
			},
			6: {
				title: "Something's not adding up here!",
				text: 'The negative product must be mandatory.'
			},
			7: {
				title: 'Houston, we have a problem!',
				text:
					'Use only Latin letters, numbers and special characters in PO Number field, no spaces or strange symbols allowed.'
			},
			8: {
				title: "Something's not adding up here!",
				text:
					'Your product cannot have a quantity of 0. Please enter a quantity.'
			},
			9: {
				title: 'We need more info before saving!',
				text: 'Please add a {value} description.',
				value: 'product type'
			},
			10: {
				title: "Something's not adding up here!",
				text: 'The negative product must have a quantity of 1.'
			},
			11: {
				title: "Something's not adding up here!",
				text: 'Please enter a payment due date.'
			},
			12: {
				title: 'We need more info before saving!',
				text: 'Please add a product/package description.'
			},
			13: {
				title: 'That discount is not going to work young apprentice!',
				text:
					'Please make sure all product/package tax options are identical otherwise the fixed discount will not work. Alternatively, you can use a percentage discount.'
			},
			14: {
				title: 'Houston, we have a problem!',
				text:
					'Only add letters into the {value} Name field, no spaces or strange symbols allowed.',
				value: 'product type'
			},
			15: {
				title: 'Double trouble!',
				text: 'This quote ID already exists. Please enter another one.'
			},
			16: {
				title: "Something's not adding up here!",
				text: 'Gift must have positive price.'
			}
		},
		i: {},
		w: {
			0: {
				title: 'We need more info before saving!',
				text: 'Please add a product/package description.'
			},
			1: {
				title: 'Elementary, my dear Watson!',
				text: 'You cannot create an quote for $0.'
			}
		}
	};

	public static editInvoice = {
		s: {},
		e: {
			0: {
				title: 'D’oh!',
				text: 'This invoice does not exist.'
			},
			1: {
				title: 'Generous, much!',
				text: 'The discount exceeds the invoice total.'
			},
			2: {
				title: "Something's not adding up here!",
				text: "You're trying to give a discount more than 100% of the order."
			},
			3: {
				title: "You're trying to send an Invoice without an invoice link!",
				text:
					"Please add the variable 'Invoice Link' to this email before sending."
			},
			4: {
				title: "Something's not adding up here!",
				text:
					'You cannot change the total of this invoice to a smaller amount than has already been paid. '
			},
			5: {
				title: 'Your invoice has gone missing in action!',
				text:
					'It looks like this invoice has been deleted and no longer exists.'
			},
			6: {
				title: "Something's not adding up here!",
				text:
					'Please make sure each payment in the payment schedule has a value greater than $0.'
			},
			7: {
				title: "You're trying to send a Receipt without an invoice link!",
				text:
					"Please add the variable 'Invoice Link' to this email before sending."
			},
			8: {
				title: "Something's not adding up here!",
				text:
					'That Invoice ID has already been used. Please choose a different Invoice ID.'
			},
			9: {
				title: "You're forgetting something!",
				text: 'Please make sure all payments have a due date.'
			},
			10: {
				title: 'Hold your horses!',
				text:
					'This payment has already been recorded automatically because a credit card payment has been made. Please refresh this page.'
			},
			11: {
				title: 'Houston, we have a Xero problem!',
				text:
					'This invoice cannot be saved because you have reached your invoice limit in Xero. Please upgrade your Xero account or UN-integrate from Xero to save this invoice.'
			},
			12: {
				title: 'We need more info before saving!',
				text: 'Please add a product/package description.'
			},
			13: {
				title: 'Double trouble!',
				text: 'This invoice ID already exists. Please enter another one.'
			},
			14: {
				title: "Something's not adding up here!",
				text: 'Please refresh the page so that the sync is complete.'
			}
		},
		i: {},
		w: {
			0: {
				title: 'We need more info before saving!',
				text: 'Please add a product/package description.'
			},
			1: {
				title: 'Elementary, my dear Watson!',
				text: 'You cannot create an invoice for $0.'
			},
			2: {
				title: 'We need more info before saving!',
				text: 'Please add a product/package.'
			}
		}
	};

	public static forgot = {
		s: {},
		e: {
			0: {
				title: 'Sorry!',
				text:
					'The email address you entered does not appear to be registered in the system'
			}
		},
		i: {},
		w: {}
	};

	public static subscription = {
		s: {
			0: {
				title: 'Woohoo!',
				text: 'You have successfully subscribed to the {value}.',
				value: 'plan'
			}
		},
		e: {
			0: {
				title: 'Sorry!',
				text: 'Your credit card number seems to be invalid.'
			},
			1: {
				title: 'Sorry!',
				text: 'The CVV number seems to be invalid.'
			},
			2: {
				title: 'Sorry!',
				text: "You've entered an invalid expiry date."
			}
		},
		i: {
			0: {
				title: 'Woohoo!',
				text: 'You have successfully subscribed to the {value} plan.',
				value: 'plan'
			},
			1: {
				title: 'Success',
				text: 'Credit card details have been updated'
			}
		},
		w: {}
	};

	public static profile = {
		s: {
			0: {
				title: 'Ding!',
				text: 'Your password settings have been saved. Please check your email.'
			},
			1: {
				title: "That's how it's done!",
				text: 'Your details have been updated.'
			},
			2: {
				title: "You've got mail!",
				text:
					'Please check your email and confirm your new email address to save these settings.'
			},
			3: {
				title: "You're ready to go!",
				text: 'Your profile image is now updated.'
			}
		},
		e: {
			0: {
				title: 'Ouch!',
				text: 'Please make sure your passwords match.'
			},
			1: {
				title: 'Even an apprentice could crack that code!',
				text: 'Your password must be at least 6 characters long.'
			},
			2: {
				title: 'Sorry!',
				text: 'That email already exists.'
			},
			3: {
				title: 'Sorry!',
				text: "That email doesn't exist."
			}
		},
		i: {
			0: {
				title: 'Is that a trick!',
				text: 'Your name has not changed.'
			},
			1: {
				title: 'Think twice!',
				text: 'The name field is empty.'
			},
			2: {
				title: "It's a trick!",
				text: 'Your email has not changed'
			}
		},
		w: {}
	};

	public static contactForm = {
		s: {
			0: {
				title: "You've earned your black belt!",
				text: 'Your contact form has been saved.'
			},
			1: {
				title: 'Success!',
				text: 'Your enquiry has been submitted.'
			}
		},
		e: {
			0: {
				title: 'Sorry!',
				text: 'Please complete all the fields and then click Submit.'
			},
			1: {
				title: "We're losing you!",
				text:
					'Your contact form has not been saved because the internet connection was lost.'
			}
		},
		i: {
			0: {
				title: 'Get ready to rumble!',
				text: 'The URL code has been copied to clipboard.'
			},
			1: {
				title: 'Get ready to rumble!',
				text: 'The embed code has been copied to clipboard.'
			}
		},
		w: {}
	};

	public static changeLogin = {
		s: {
			0: {
				title: 'Woohoo!',
				text: 'Your email address has been successfully updated.'
			}
		},
		e: {
			0: {
				title: 'Damn!',
				text: 'The link to update your email address has already been used.'
			}
		},
		i: {},
		w: {}
	};

	public static stripe = {
		s: {
			0: {
				title: 'Congratulations!',
				text: 'Your credit card payment was successful.'
			}
		},
		e: {
			0: {
				title: "Oops, your payment hasn't processed!",
				text: 'Please contact your photographer.'
			},
			1: {
				title: 'Whoops!',
				text: "You've entered an invalid security code. Please try again."
			},
			2: {
				title: 'Uh-oh!',
				text: 'Your CVV code was incorrect.'
			},
			3: {
				title: 'Oops!',
				text: 'Attempts to charge your card failed.'
			},
			4: {
				title: 'That’s not going to work!',
				text: 'Your card was declined.'
			},
			5: {
				title: 'Ouch!',
				text: 'Your card has insufficient funds.'
			},
			6: {
				title: 'Dear dear!',
				text: 'Your card has expired.'
			},
			7: {
				title: 'Yikes!',
				text:
					'Something’s gone wrong while processing your card. Try again later!'
			},
			8: {
				title: 'Whoops!',
				text:
					'We could not process your payment. Please try again later or contact your bank.'
			}
		},
		i: {
			0: {
				title: 'Hold your horses!!',
				text:
					'Your details are being processed and more verification is required for added security.'
			}
		},
		w: {}
	};
	public static shootProof = {
		s: {
			0: {
				title: 'From ShootProof to hero!',
				text: 'Your ShootProof account is now connected.'
			},
			1: {
				title: 'Woohoo, fire away!',
				text: 'You have successfully created a new gallery in ShootProof.'
			},
			2: {
				title: 'From ShootProof to hero!',
				text: 'You have successfully disconnected your account from ShootProof.'
			},
			3: {
				title: 'Woohoo, fire away!',
				text: 'You have successfully linked an existing gallery in ShootProof.'
			},
			4: {
				title: 'Woohoo, fire away!',
				text: 'You have successfully saved your ShootProof settings.'
			},
			5: {
				title: 'From ShootProof to hero!',
				text: 'You have successfully deleted a ShootProof gallery.'
			},
			6: {
				title: 'Woohoo, fire away!',
				text: 'You have successfully integrated to ShootProof.'
			},
			7: {
				title: "That's Shoot-tastic!",
				text: 'Your order has been successfully imported.'
			}
		},
		e: {
			0: {
				title: "Stop! Don't Shoot...Proof!",
				text:
					'You are no longer integrated with ShootProof. Please integrate again.'
			},
			1: {
				title: "Stop! Don't Shoot...Proof!",
				text:
					'Unfortunately you cannot create a new gallery with invalid contact information.'
			}
		}
	};

	public static lead = {
		s: {
			0: {
				title: 'Mission accomplished!',
				text: 'Your lead has now become a job.'
			},
			1: {
				title: 'Mission accomplished!',
				text: 'Your job has now become a lead.'
			},
			2: {
				title: 'Be gone!',
				text: 'Your lead was successfully deleted.'
			},
			3: {
				title: 'Mission accomplished!',
				text: 'Your lead details have been updated.'
			},
			4: {
				title: 'Mission accomplished!',
				text: 'A new lead has been created.'
			},
			5: {
				title: 'File away!',
				text: 'Your lead has been archived.'
			},
			6: {
				title: 'Shake off the dust!',
				text: 'Your lead has been unarchived'
			}
		},
		e: {
			0: {
				title: 'Measure twice, cut once!',
				text: 'Please select or create a primary contact for this lead.'
			},
			1: {
				title: "You're forgotten something!",
				text:
					"Please add a name for this lead, for example Jenny & Matt's Wedding."
			},
			2: {
				title: "You've doubled up!",
				text:
					'The secondary client needs to be different from the primary client.'
			},
			3: {
				title: 'Your timing is off!',
				text:
					"Please enter a start and end time or tick 'all day' if this is an all day event."
			},
			4: {
				title: 'Oopsy!',
				text: 'Delete your invoices before you can archive this lead.'
			},
			5: {
				title: 'Computer says no!',
				text: 'Unarchive this lead before you can edit it.'
			},

			6: {
				title: 'Computer says no!',
				text: 'Unarchive this lead before you can delete it.'
			}
		},
		i: {},
		w: {}
	};

	public static qb = {
		s: {
			0: {
				title: 'Woohoo, that was quick!',
				text: 'This invoice has been successfully copied to Quickbooks.'
			},
			1: {
				title: 'Woohoo, that was quick!',
				text: 'You have successfully disconnected your Quickbooks integration.'
			},
			2: {
				title: 'Woohoo, that was quick!',
				text: 'You have successfully integrated with Quickbooks.'
			}
		},
		e: {
			0: {
				title: 'Slow down, Quickbooks error!',
				text:
					'As you are integrated with Quickbooks, please make sure each product/package has the same tax type assigned before saving.'
			},
			1: {
				title: 'Slow down, Quickbooks error!',
				text:
					'The invoice ID {value} has already been used in Quickbooks. Please change the invoice ID before saving this invoice.',
				value: 'invoice id'
			},
			2: {
				title: "Something's not adding up here!",
				text:
					'Your Quickbooks account does not have any Payment Accounts. Please setup a Payment Account and try again.'
			},
			3: {
				title: 'Slow down, Quickbooks error!',
				text:
					'Quickbooks does not allow invoices to have the tax type "Includes Tax". Please change the tax type to "Excludes Tax" and try again.'
			},
			4: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This account has been disconnected from Quickbooks. Please go to Settings > Integrations and connect to Quickbooks again.'
			},
			5: {
				title: 'Slow down, Quickbooks error!',
				text:
					'Your account is already connected with another accounting platform. Please disconnect and try again.'
			},
			6: {
				title: 'Slow down, Quickbooks error!',
				text:
					'A client with the same first name and last name already exists. Please change the name to continue.'
			},
			7: {
				title: 'Slow down, Quickbooks error!',
				text: 'Quickbooks does not allow invoice payments to be written off.'
			},
			8: {
				title: 'Slow down, Quickbooks error!',
				text: 'Quickbooks is not supported in France at the time.'
			},
			9: {
				title: 'Slow down, Quickbooks error!',
				text:
					'Your tax rate is set to 0% in Quickbooks. Please make sure the same tax rate is set in Studio Ninja.'
			},
			10: {
				title: 'Slow down, Quickbooks error!',
				text: 'Quickbooks does not support the characters used in this invoice.'
			},
			11: {
				title: 'Slow down, Quickbooks error!',
				text:
					'The client attached to this invoice has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks before making changes to this invoice.'
			},
			12: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This payment has already been voided or deleted in Quickbooks. Undo this in Quickbooks and try again.'
			},
			14: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This payment has a credit note attached to it in Quickbooks. Studio Ninja does not support this feature. Please remove the credit note first before recording this payment.'
			},
			15: {
				title: 'Slow down, Quickbooks error!',
				text: 'Your Invoice ID has too many characters. '
			},
			16: {
				title: 'Slow down, Quickbooks error!',
				text:
					'While integrated with Quickbooks you cannot Write Off payments. This feature is not supported by Quickbooks.'
			},
			17: {
				title: 'Slow down, Quickbooks error!',
				text:
					'You cannot copy this invoice to Quickbooks because you have deleted it in Quickbooks.'
			},
			18: {
				title: 'Slow down, Quickbooks error!',
				text:
					'You cannot save this invoice because the clients email address is invalid.'
			},
			19: {
				title: 'Slow down, Quickbooks error!',
				text:
					'Quickbooks requires that all invoices include tax. Please update your products/packages tax rate and try again.'
			},
			20: {
				title: 'Slow down, Quickbooks error!',
				text:
					'The client attached to this job has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks before creating the invoice.'
			},
			21: {
				title: 'Slow down, Quickbooks error!',
				text:
					'QuickBooks company should have at least one Tax Code with sales tax rates'
			},
			22: {
				title: 'Slow down, Quickbooks error!',
				text:
					'QuickBooks does not support fixed discounts. Please choose a percentage discount before continuing.'
			},
			23: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This client has been marked as inactive in Quickbooks. Please reactivate the client in Quickbooks.'
			},
			24: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This invoice cannot be saved because the same product/package name already exists as a category in QuickBooks. Please use a different product/package name to continue.'
			},
			25: {
				title: 'Slow down, Quickbooks error!',
				text:
					'This invoice cannot be saved because the same product/package name already exists as a Inventory or Bundle in QuickBooks. Please use a different product/package name to continue.'
			},
			26: {
				title: 'Slow down, Quickbooks error!',
				text: 'Your Product / Package name has too many characters.'
			},
			27: {
				title: 'Slow down, Quickbooks error!',
				text: 'Your invoice ID has too many characters.'
			},
			28: {
				title: 'Slow down, Quickbooks error!',
				text: 'Your Description has too many characters.'
			}
		},
		i: {
			0: {
				title: 'The countdown begins, 10, 9, 8...!',
				text: 'Please wait while we connect your account to Quickbooks.'
			}
		},
		w: {
			0: {
				title: 'Slow down, Quickbooks warning!',
				text: 'Your Description has too many characters.'
			}
		}
	};

	public static xero = {
		s: {
			0: {
				title: 'From Xero to hero!',
				text: 'Your Xero account is now connected.'
			},
			1: {
				title: 'From Xero to hero!',
				text: 'This invoice has been successfully copied to Xero.'
			},
			2: {
				title: 'From Xero to hero!',
				text: 'You have successfully disconnected your account from Xero.'
			}
		},
		e: {
			0: {
				title: 'Houston, we have a Xero problem!',
				text:
					'This payment has already been recorded in Xero. Please remove the payment from Xero first before recording the payment in Studio Ninja.'
			},
			1: {
				title: 'Houston, we have a Xero problem!',
				text:
					'Invoices with a fixed discount are not compatible with Xero. Please make sure you apply a percentage discount before saving.'
			},
			2: {
				title: 'Xero no go!',
				text:
					"Something went wrong while syncing this invoice to Xero. Please click on the 'Copy to Xero' button to try again."
			},
			3: {
				title: 'Houston, we have a Xero problem!',
				text:
					'This invoice cannot be copied to Xero because it has been voided in Xero. Please un-void the invoice in Xero to continue.'
			},
			4: {
				title: 'Houston, we have a Xero problem!',
				text:
					'Invoices with multiple tax type are not compatible with Xero. Please make sure all the tax types are the same before saving.'
			},
			5: {
				title: 'Houston, we have a Xero problem!',
				text:
					'This invoice cannot be copied to Xero because it has already been partially or fully paid in Xero.'
			},
			6: {
				title: 'Houston, we have a Xero problem!',
				text:
					'The invoice ID {value} already exists in Xero. Please choose a different invoice ID before saving.',
				value: 'invoice id'
			},
			7: {
				title: 'Houston, we have a Xero problem!',
				text: 'Invoices with written off payments are not compatible with Xero.'
			},
			8: {
				title: 'Houston, we have a Xero problem!',
				text: '$0 payments are not compatible with Xero.'
			},
			9: {
				title: 'Houston, we have a Xero problem!',
				text:
					'You cannot record a payment to this invoice because this invoice has been voided in Xero.'
			},
			10: {
				title: 'Houston, we have a Xero problem!',
				text:
					'The contact details for this job cannot be modified because there are linked invoices with Xero for this job with the current client details.'
			},
			11: {
				title: 'Houston, we have a Xero problem!',
				text:
					'This payment cannot be marked as unpaid because it was overpaid in Xero. Please remove the payment in Xero first to continue.'
			},
			12: {
				title: 'Houston, we have a Xero problem!',
				text:
					'Please remove the overpaid amount in Xero before deleting this {value}.',
				value: 'deletedItem'
			},
			13: {
				title: 'Slow down, Xero error!',
				text:
					'Your account is already connected with another accounting platform. Please disconnect and try again. '
			},
			14: {
				title: 'Bummer!',
				text: 'Your Xero access token has been revoked. Please reconnect Xero.'
			},
			15: {
				title: 'Bummer!',
				text: "You don't have an active Xero subscription."
			},
			16: {
				title: 'Houston, we have a Xero problem!',
				text:
					'The contact details for this job cannot be modified because there are linked invoices with Xero for this job with the current client details.'
			},
			17: {
				title: 'Houston, we have a Xero problem!',
				text:
					'The contact details for this lead cannot be modified because there are linked invoices with Xero for this lead with the current client details.'
			}
		},
		i: {},
		w: {}
	};

	public static promoCodes = {
		s: {},
		e: {
			0: {
				title: 'Eek!',
				text: 'This promo code has expired.'
			},
			1: {
				title: 'Sorry!',
				text: 'That is not a valid promo code.'
			},
			2: {
				title: "I think you're forgetting something!",
				text: 'Please enter a promo code.'
			}
		},
		i: {
			0: {
				title: 'Copy that!',
				text:
					'The text has been successfully copied. Now go share it with the world.'
			}
		},
		w: {}
	};

	public static attachments = {
		s: {
			0: {
				title: 'Success!',
				text: 'The file was downloaded to {value}.'
			}
		},
		e: {
			0: {
				title: 'Sorry!',
				text: 'The promo code you entered is either invalid or expired.'
			}
		},
		i: {},
		w: {
			0: {
				title: "You're running out of space!",
				text: 'You cannot attach more than 10mb of file/s.'
			},
			1: {
				title: "You're running out of space!",
				text: 'You can only upload a total of 20mb per job.'
			}
		}
	};

	public static generalValidation = {
		s: {},
		e: {
			0: {
				title: 'Mayday mayday!',
				text: 'Please enter a valid web address or email address.'
			},
			1: {
				title: 'Sorry!',
				text:
					'The email could not be delivered to {value} because it is invalid. Please update this clients email address and try again.',
				value: 'email'
			},
			2: {
				title: 'Mayday mayday!',
				text:
					"You've forgotten to add a reminder message. Please add a message before saving."
			},
			3: {
				title: 'Mayday mayday!',
				text:
					"You've forgotten to add days variable. Please add the number of days  before saving."
			},
			4: {
				title: 'Hold your horses!',
				text:
					'You have exceeded your limit of sending {value} emails per day. Please contact support or wait until tomorrow to continue sending emails.',
				value: 'limit'
			}
		},
		i: {},
		w: {}
	};
	public static subscribed = {
		s: {
			0: {
				title: 'Hooray!',
				text: 'The client is now subscribed to receive emails.'
			},
			1: {
				title: 'Roger that!',
				text: 'The client has been unsubscribed.'
			}
		}
	};
	public static fundy = {
		s: {
			0: {
				title: 'Yowza!',
				text: 'Fundy invoicing features have been enabled.'
			},
			1: {
				title: "Don't get funky!",
				text: 'Fundy invoicing features have been disabled.'
			},
			2: {
				title: 'Zing!',
				text: 'Your invoice has been imported from Fundy.'
			}
		},
		e: {
			0: {
				title: 'Not happy, Fundy!',
				text: 'Your invoice must contain at least one order.'
			},
			1: {
				title: 'Not happy, Fundy!',
				text: 'Your invoice subtotal must match the line items.'
			},
			2: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must not have a credit value.'
			},
			3: {
				title: 'Not happy, Fundy!',
				text: 'Your invoice tax rate must match your tax settings.'
			},
			4: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must contain a client order.'
			},
			5: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must be in xml file format.'
			},
			6: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must be under 5 mb.'
			},
			7: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must have a valid quantity parameter.'
			},
			8: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must have a valid price parameter.'
			},
			9: {
				title: 'Not happy, Fundy!',
				text: 'Your uploaded file must have a valid discount parameter.'
			},
			10: {
				title: 'Not happy, Fundy!',
				text: 'Discount must be less than subtotal.'
			},
			11: {
				title: 'Not happy, Fundy!',
				text: '{value}',
				value: 'message from backend'
			},
			12: {
				title: 'Not happy, Fundy!',
				text: "You can't upload an empty Xml file."
			}
		}
	};
	public static quoteCP = {
		e: {
			0: {
				title: 'Oops!',
				text:
					'For your chosen products, please enter a quantity of more than 0.'
			},
			1: {
				title: 'Sorry!',
				text: 'Please enter a reason for declining the quote.'
			},
			2: {
				title: 'Oops!',
				text: 'Please select a package or product first.'
			}
		}
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=cbiehorjf0u!./shared/models/messages.ts